import { render, staticRenderFns } from "./TOCTemp2.vue?vue&type=template&id=61526281&scoped=true&"
import script from "./TOCTemp2.vue?vue&type=script&lang=js&"
export * from "./TOCTemp2.vue?vue&type=script&lang=js&"
import style0 from "./TOCTemp2.vue?vue&type=style&index=0&id=61526281&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61526281",
  null
  
)

export default component.exports